import React from "react";
import { ChromePicker } from "react-color";
import onClickOutside from "react-onclickoutside";

export declare module CustomColorPickerModule {
  export interface Props {
    className?: string;
    currentColor: string;
    handleChangeColor: (color) => void;
    displayColorPicker: boolean;
    handleClosePicker: () => void;
    disableOnClickOutside: (boolean) => boolean;
  }

  export interface State {}
}

class CustomColorPicker extends React.Component<CustomColorPickerModule.Props, CustomColorPickerModule.State> {
  myClickOutsideHandler = (e) => {
    this.props.handleClosePicker();
  };

  componentDidMount() {
    this.props.disableOnClickOutside(true);
  }

  render() {
    return (
      <>
        {this.props.displayColorPicker ? (
          <div className={this.props.className} style={{ position: "absolute", zIndex: 2 }}>
            <ChromePicker
              color={this.props.currentColor}
              onChangeComplete={(color) => this.props.handleChangeColor(color)}
            />
          </div>
        ) : null}
      </>
    );
  }
}

const clickOutsideConfig = {
  handleClickOutside: function (instance) {
    return instance.myClickOutsideHandler;
  },
};

export default onClickOutside(CustomColorPicker, clickOutsideConfig);
